import React, { useEffect, useState } from "react";

import Header from "./header";

import "react-toastify/dist/ReactToastify.min.css";

const AuthLayout = ({ children }) => {
  return (
    <>
      <div className="min-h-screen bg-gray-100">
        <Header />
        <>{children}</>
      </div>
    </>
  );
};

export default AuthLayout;
